import { Briefcase, Cpu, ChevronDown } from "lucide-react";
import { ENGINES } from "../lib/models";

/* Small, good-looking dropdowns reused across the website + extension so the
   model choice and the C2C/Full-Time choice look and behave identically everywhere.
   Native <select> = zero extra deps, consistent, and remembers the current value. */

export const EMPLOYMENT_OPTIONS = [
  { value: "contract-c2c", label: "Contract (C2C)" },
  { value: "full-time", label: "Full-Time" },
];

const selectBase =
  "appearance-none w-full pl-8 pr-8 py-2 rounded-lg border border-border bg-background text-foreground " +
  "text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary/30 cursor-pointer " +
  "hover:border-primary/50 transition-colors";

export function EmploymentSelect({ value, onChange, testid = "employment-select", className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <Briefcase size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
      <select data-testid={testid} value={value || "contract-c2c"} onChange={(e) => onChange(e.target.value)} className={selectBase}>
        {EMPLOYMENT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <ChevronDown size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
    </div>
  );
}

export function EngineSelect({ value, onChange, keys, testid = "engine-select", className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <Cpu size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
      <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className={selectBase}>
        {keys.map((k) => (
          <option key={k} value={k}>
            {ENGINES[k]?.label || k}{ENGINES[k]?.tagline ? ` · ${ENGINES[k].tagline}` : ""}
          </option>
        ))}
      </select>
      <ChevronDown size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
    </div>
  );
}
